import { getUA } from './use-web-rtc'

export const start = (): void => {
  getUA()?.start()
}
